<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Notification Settings</span><br/>
    </div>

    <div v-if="!loading" style="text-align: left; color: #666; " class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
<!--          <tr>-->
<!--            <td width="500" align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isGeneralVisible')">&#8594; General</span></td>-->
<!--            <td width="800">&nbsp;</td>-->
<!--            <td width="450">&nbsp;</td>-->
<!--          </tr>-->
<!--          <template v-if="toggle.isGeneralVisible">-->
<!--            <tr>-->
<!--              <td align="right" width="500"> Message Sender</td>-->
<!--              <td width="800"><b-form-select v-model="model.group_message_sender_include_telematics_drivers" :options="boolean_options" style="width:100px"></b-form-select></td>-->
<!--              <td width="450">&nbsp;</td>-->
<!--            </tr>-->
<!--          </template>-->
          <tr>
            <td width="500" align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isGroupMessageSenderVisible')">&#8594; Group Message Sender</span></td>
            <td width="800"><b-form-select v-model="model.group_message_sender_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="450">&nbsp;</td>
          </tr>
          <template v-if="toggle.isGroupMessageSenderVisible">
            <tr>
              <td align="right" width="500">Test Mode</td>
              <td width="800"><b-form-select v-model="model.group_message_sender_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="450">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Include Telematics Drivers</td>
              <td width="800"><b-form-select v-model="model.group_message_sender_include_telematics_drivers" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="450">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td width="500" align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isDriverPreVisible')">&#8594; Driver Pre Trip Notifications</span></td>
            <td width="800"><b-form-select v-model="model.driver_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="450">&nbsp;</td>
          </tr>
          <template v-if="toggle.isDriverPreVisible">
            <tr>
              <td align="right" width="500">Test Mode</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="450">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Contracts Enabled</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_contracts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Private Hires Enabled</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_private_hires_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Booking Updates Enabled</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_enable_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Hours Before</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_send_hours_before" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Hours Before By Day</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_send_hours_before_by_day" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Only At Hour</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_send_only_at_hour" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Only During Business Hours</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_business_hours" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Response Email Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_response_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Response Email Config</td>
              <td width="800"><b-form-textarea v-model="model.driver_trip_notifications_response_email_config" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Failure Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_failed_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Minutes</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_confirmation_minutes" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Email Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_confirmation_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Advanced Config</td>
              <td width="800"><b-form-textarea v-model="model.driver_trip_notifications_confirmation_advanced_config" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Skip By Route Name</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_skip_routes" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="telematics_type == 'SAMSARA'">
              <td align="right" width="500">Vehicle Tag Filter</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_vehicle_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Skip Non Telematics Vehicles</td>
              <td width="800"><b-form-select v-model="model.driver_trip_notifications_skip_non_telematics_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="telematics_type == 'SAMSARA'">
              <td align="right" width="500">Driver Tag Filter</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_driver_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Driver Name Filter</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_driver_name_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Client ID Filter</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_client_id_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">Booking Base Filter</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_booking_base_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">Booking POC Field</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.driver_trip_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="500">Driver Instructions Marker</td>
              <td width="800"><b-form-input v-model="model.driver_trip_notifications_driver_instruction_marker" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isDriverPostVisible')">&#8594; Driver Post Trip Notification</span></td>
            <td width="800"><b-form-select v-model="model.post_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isDriverPostVisible">
            <tr>
              <td align="right" width="500">Email Only</td>
              <td width="800"><b-form-select v-model="model.post_trip_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.post_trip_notifications_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send After Complete</td>
              <td width="800"><b-form-select v-model="model.post_trip_notifications_send_after_complete" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.post_trip_notifications_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Filter By Booking Type</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_booking_type_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Minutes After</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_send_minutes_after" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Response Email Recipients</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_response_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Response Email Config</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_response_email_config" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.post_trip_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Minutes</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_confirmation_minutes" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Confirmation Email Address</td>
              <td width="800"><b-form-input v-model="model.post_trip_notifications_confirmation_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isCustomerPreVisible')">&#8594; Customer Pre Trip Notification</span></td>
            <td width="800"><b-form-select v-model="model.customer_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isCustomerPreVisible">
            <tr>
              <td align="right" width="500">Test Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">External API Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_api_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send To Contracts Enabled</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_contracts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Include Driver Name With Farm Out Info</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_include_driver_name_with_farm_out" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send To Private Hires Enabled</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_private_hires_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Resend On Booking Update Enabled</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_enable_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Use Operations Contact Only</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_use_operations_contact_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Hours Before</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_send_hours_before" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Hours By Day</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_send_hours_before_by_day" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Only At Hour</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_send_only_at_hour" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send During Business Hours</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_business_hours" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Booking Field To Find POC Info</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">POC Error Email Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Failure Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_failed_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Failure Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_failed_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Image Site URL</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_image_site_url" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Sender Prefix</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_email_sender_prefix" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Subject</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_email_subject" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Response Forward Address</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_email_response_forward_address" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Reply-To Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_email_reply_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Config</td>
              <td width="800"><b-form-textarea v-model="model.customer_trip_notifications_email_config" style="field-sizing: content"></b-form-textarea></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Receipients Exclusions</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_sms_recipients_exclude" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Booking Group Field</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_group_field" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Vehicle Mappings</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_vehicle_mappings" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>

            <tr>
              <td align="right" width="500">Filter By Company ID</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_company_id_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Filter By Booking Type</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_booking_type_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Filter By Client ID</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_client_id_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">Booking Base Filter</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_booking_base_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="telematics_type == 'SAMSARA'">
              <td align="right" width="500">Vehicle Tag Filter</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_vehicle_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Skip Non Telematics Vehicles</td>
              <td width="800"><b-form-select v-model="model.customer_trip_notifications_skip_non_telematics_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Client ID POC Override</td>
              <td width="500"><b-form-input v-model="model.customer_trip_notifications_client_id_poc_override" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Filter By Driver Type</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_driver_type_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Filter By Vehicle Type</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_vehicle_type_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.customer_trip_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Farm Out SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.customer_trip_notifications_farm_out_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Customer HTML Template File</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_customer_html_file" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">HTML Template</td>
              <td width="800">
                <b-form-textarea v-model="model.customer_trip_notifications_customer_html_template" style="field-sizing: content"/>
                <template>
                  <a target='_blank' :href="'https://api.fleet-integrations.com/bookings/alerts/showHtml?tenant=' + user.tenant + '&type=cust'">
                    <b-button variant="">Show html in browser</b-button>
                  </a>
                </template>
              </td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Test HTML Email Address</td>
              <td width="800"><b-form-input v-model="model.customer_trip_notifications_test_html_email_address" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Test HTML</td>
              <td width="800"><b-button variant="" @click="test_cust_pre_trip_alert_html()">Send Email To Above Address</b-button></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Settings</td>
              <td width="800"><b-button variant="" @click="manage_cust_events = !manage_cust_events">Manage Alert Settings</b-button></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr v-if="tenant_type == 'CM'">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isCustomerPostVisible')">&#8594; Customer Post Trip Notification</span></td>
            <td width="800"><b-form-select v-model="model.customer_post_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isCustomerPostVisible">
            <tr>
              <td align="right" width="500">Test Mode</td>
              <td width="800"><b-form-select v-model="model.customer_post_trip_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Only At Hour</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_send_only_at_hour" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">Booking POC Field</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Subject</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_email_subject" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Config</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_email_config" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="500">POC Error Email Recipients</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Group Field</td>
              <td width="800"><b-form-input v-model="model.customer_post_trip_notifications_group_field" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.customer_post_trip_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr v-if="this.user.tenant_name.indexOf('AAAHI') != -1">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isDriverSurveyVisible')">&#8594; Customer Survey Notifications</span></td>
            <td width="800"><b-form-select v-model="model.driver_surveys_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isDriverSurveyVisible">
            <tr>
              <td align="right" width="500">Email Only</td>
              <td width="800"><b-form-select v-model="model.driver_surveys_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Test Email Only</td>
              <td width="800"><b-form-select v-model="model.driver_surveys_test_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_surveys_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Subject</td>
              <td width="800"><b-form-input v-model="model.driver_surveys_email_subject" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Only At Hour</td>
              <td width="800"><b-form-input v-model="model.driver_surveys_send_only_at_hour" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.driver_surveys_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">HTML Template</td>
              <td width="800">
                <b-form-textarea v-model="model.driver_surveys_html_template" style="field-sizing: content"/>
                <template>
                  <a target='_blank' :href="'https://api.fleet-integrations.com/bookings/alerts/showHtml?tenant=' + user.tenant + '&type=driver'">
                    <b-button variant="">Show html in browser</b-button>
                  </a>
                </template>
              </td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Test HTML Email Address</td>
              <td width="800"><b-form-input v-model="model.driver_surveys_test_html_email_address" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Send Test HTML Email</td>
              <td width="800"><b-button variant="" @click="test_driver_survey_alert_html()">Send Email To Above Address</b-button></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr v-if="tenant_type == 'CM'">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isPassPreVisible')">&#8594; Passenger Pre Trip Notification</span></td>
            <td width="800"><b-form-select v-model="model.passenger_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isPassPreVisible">
            <tr>
              <td align="right" width="500">Email Only</td>
              <td width="800"><b-form-select v-model="model.passenger_trip_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.passenger_trip_notifications_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Hours Before</td>
              <td width="800"><b-form-input v-model="model.passenger_trip_notifications_hours_before" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Skip Bookings</td>
              <td width="800"><b-form-input v-model="model.passenger_trip_notifications_skip_bookings" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template Day Of</td>
              <td width="800"><b-form-textarea v-model="model.passenger_trip_notifications_sms_template_day_of" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.passenger_trip_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'">
              <td align="right" width="500">SMS Template For Tour Types</td>
              <td width="800"><b-form-textarea v-model="model.passenger_trip_notifications_sms_template_tour_type" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'">
              <td align="right" width="500">SMS Template For Cruise Express</td>
              <td width="800"><b-form-textarea v-model="model.passenger_trip_notifications_sms_template_cruise_express" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'">
               <td align="right" width="500">SMS Template For Florida Cruise Express</td>
              <td width="800"><b-form-textarea v-model="model.passenger_trip_notifications_sms_template_florida_cruise_express" style="field-sizing: content"/></td>
               <td width="250">&nbsp;</td>
             </tr>
          </template>
          <tr v-if="tenant_type == 'CM'">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isRelayVisible')">&#8594; Relay Notifications</span></td>
            <td width="800"><b-form-select v-model="model.relay_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isRelayVisible">
            <tr>
              <td align="right" width="500">Test Mode (Alert record, no email or sms sent)</td>
              <td width="800"><b-form-select v-model="model.relay_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Email Only</td>
              <td width="800"><b-form-select v-model="model.relay_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
             <tr>
               <td align="right" width="500">Email Recipients</td>
               <td width="800"><b-form-input v-model="model.relay_notifications_email_recipients" type="text"></b-form-input></td>
               <td width="250">&nbsp;</td>
             </tr>
            <tr v-if="tenant_type == 'CM'">
               <td align="right" width="500">POC Error Email Recipients</td>
               <td width="800"><b-form-input v-model="model.relay_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
               <td width="250">&nbsp;</td>
             </tr>
             <tr>
              <td align="right" width="500">Minutes Threshold</td>
              <td width="800"><b-form-input v-model="model.relay_notifications_minutes_threshold" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Distance Threshold</td>
              <td width="800"><b-form-input v-model="model.relay_notifications_distance_threshold" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Minutes Before</td>
              <td width="800"><b-form-input v-model="model.relay_notifications_minutes_before" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Minutes After</td>
              <td width="800"><b-form-input v-model="model.relay_notifications_minutes_after" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.relay_notifications_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">API Enabled</td>
              <td width="800"><b-form-select v-model="model.relay_notifications_api_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
        </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Manage Cust Alert Settings" size="huge" v-model="manage_cust_events" ok-only id="custModal" @ok="custModelOK($event)">
      <div style="color:red; font-weight:bold;" v-if="this.show_cust_error">
        <b>{{this.cust_error_msg}}</b><br/>
      </div>
      <b> If Send Hour is added, this will be the only hour the alert will send (HoursByDay/OnlyAtHour). But if business hours is set outside of the send hour, the alert will not be sent. (Only set Send Hour inside business hours)
        <br/><br/>Customize text and add any of these template fields:
        [vehicleID], [charterID], [movementID], [clientID], [bookingType],
        [leaderName], [leaderNumber], [driverName], [driverNumber],
        [startDate], [startTime], [spotTime], [pickupTime], [backTime], [finishTime],
        [startTime24], [spotTime24], [pickupTime24], [backTime24], [finishTime24],
        [pickupLocation], [groupName], [bookingMapLink], [pickupMapLink]</b><br/><br/>
      <div v-if="loading">
        <b-spinner style="width: 2rem; height: 1rem;" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-table v-if="this.cust_alert_event_settings" :items="this.cust_alert_event_settings" :fields="['eventName','eventType','hours','sendHour','M','T','W','TH','F','SA','SU','update','remove']">
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="update_cust_event(row.item.eventName)">update</b-button>
            <br/>
          </template>
          <template slot="remove" slot-scope="row">
            <b-button size="sm" @click="delete_cust_event(row.item.eventName)">remove</b-button>
          </template>
        </b-table>
        <hr/>
        <div style="font-weight: bold; font-size: 18px;" v-on:click="add_new_alert()">&#43; Add New Alert</div><br/>
        <span :style="toggle.isAddCustEventVisible ? '' : 'display:none'">
            <div><b>
              Event type: <b-form-select v-model="add_cust_event_model.eventType" :options="cust_event_options" @change="eval_event" :disabled=disable_cust_options style="width:200px"></b-form-select><br/>
              Event name: <b-form-input v-model="add_cust_event_model.eventName" required :disabled=disable_cust_name></b-form-input>
              Send Hour(s) Before: <b-form-input v-model="add_cust_event_model.hours" :disabled=isDisabled(add_cust_event_model)></b-form-input>
              Send Only At Hour: <b-form-input v-model="add_cust_event_model.sendHour" :disabled=!isDisabled(add_cust_event_model)></b-form-input>
              Monday: <b-form-input v-model="add_cust_event_model.M" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Tuesday: <b-form-input v-model="add_cust_event_model.T" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Wednesday: <b-form-input v-model="add_cust_event_model.W" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Thursday: <b-form-input v-model="add_cust_event_model.TH" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Friday: <b-form-input v-model="add_cust_event_model.F" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Saturday: <b-form-input v-model="add_cust_event_model.SA" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Sunday: <b-form-input v-model="add_cust_event_model.SU" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Template: <b-form-textarea v-model="add_cust_event_model.template" :rows="10" required/>
            </b></div><br/>
            <div style="color:red; font-weight:bold;" v-if="this.show_cust_error">
            <b>{{this.cust_error_msg}}</b><br/>
            </div>
            <b-button v-if="!loading" variant="success" size="sm" @click="add_cust_event()">Save Alert Event</b-button>
          </span>
      </div>
    </b-modal>

  </div>

</template>
<script>
import {get_tenant_config_settings, add_cust_event, delete_cust_event, test_html_alert, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import { provide } from "vue";
import { RichTextEditorComponent as EjsRichtexteditor, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-vue-richtexteditor';


export default {
  name: 'tenant_config',
  components: {
//    'ejs-richtexteditor': RichTextEditorComponent

  },
  provide:{
    richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
  },

  data() {
    return {
      cust_alert_event_settings: null,
      add_cust_event_model: {},
      manage_cust_events: false,
      show_cust_error: false,
      disable_cust_options: false,
      disable_cust_name: false,
      cust_error_msg: "",
      model: {},
      toggle: {},
      summary: {},
      loading: true,
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      cust_event_options: [
        { text: 'HoursBefore', value: 'hrsbfr' },
        { text: 'HoursByDay', value: 'hrsbday' },
        { text: 'OnlyAtHour', value: 'onlyhr' },
      ]
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

        //Setup day hours values for readability
        try {
          if (this.model.customer_trip_notifications_alerts_settings != null && this.model.customer_trip_notifications_alerts_settings != "") {
            this.cust_alert_event_settings = JSON.parse(this.model.customer_trip_notifications_alerts_settings)

            if (this.cust_alert_event_settings) {
              for (const event of this.cust_alert_event_settings) {
                if (event.dayHours) {
                  for (const dayhrs of event.dayHours.split(';')) {
                    if (dayhrs != null) {
                      const day = dayhrs.split('=')[0]
                      const hrs = dayhrs.split('=')[1]
                      if ('Monday' == day) {
                        event['M'] = hrs
                      }
                      if ('Tuesday' == day) {
                        event['T'] = hrs
                      }
                      if ('Wednesday' == day) {
                        event['W'] = hrs
                      }
                      if ('Thursday' == day) {
                        event['TH'] = hrs
                      }
                      if ('Friday' == day) {
                        event['F'] = hrs
                      }
                      if ('Saturday' == day) {
                        event['SA'] = hrs
                      }
                      if ('Sunday' == day) {
                        event['SU'] = hrs
                      }
                    }
                  }
                }
              }
            }
          }
        } catch(e) {
          console.log('exception converting cust alert settings to json:', e)
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        
        //return value to object 
        try {
          //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
          for (const objkey of this.objectKeyList) {
            //console.log("objkey:" + objkey + " obj: " + this.model[objkey])
            try{
              let setting = JSON.parse(this.model[objkey])
              this.model[objkey] = setting
            } catch(ex) {
              console.log('vexception parsing object ' + objkey, ex)
            }
          }
        } catch(e) {
          console.log('vexception parsing object keys' + e)
        }

        await update_tenant_config_settings(this.user.tenant, this.model)
        this.load_data()
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async test_cust_pre_trip_alert_html() {
      if (!this.model.customer_trip_notifications_test_html_email_address) {
        alert("Please enter an email address above and save")
        return
      }
      if (!this.model.customer_trip_notifications_customer_html_template) {
        alert("Please enter a template and save")
        return
      }
      if (confirm("Are you sure you want to send test customer pre-trip notifications email?")) {
        await test_html_alert(this.user.tenant, "CustomerTripNotificationTest")
        this.$emit('showAlert', 'test html sent', 'info', 5000)
      }
    },
    async test_driver_survey_alert_html() {
      console.log('driver_surveys_test_html_email_address = ' + this.model.driver_surveys_test_html_email_address)
      if (!this.model.driver_surveys_test_html_email_address) {
        alert("Please enter an email address above and save")
        return
      }
      if (!this.model.driver_surveys_html_template) {
        alert("Please enter a template and save")
        return
      }
      if (confirm("Are you sure you want to send test customer survey notifications email?")) {
        await test_html_alert(this.user.tenant, "DriverTripNotificationTest")
        this.$emit('showAlert', 'test html sent', 'info', 5000)
      }
    },
    async custModelOK($event) {
      this.add_cust_event_model = {}
      this.cust_error_msg = ""
      this.show_cust_error = false
      this.update_toggle_div(this.toggle, 'isAddCustEventVisible', false)
    },
    async process_dayhours(event) {
      //console.log("process_dayhours: event:" + event + " new cust_alert_event_settings: " + JSON.stringify(event))
      if (this.cust_alert_event_settings != null) {
        for (let event of this.cust_alert_event_settings) {
          if (event.eventType === 'hrsbday') {
            let dayhours = ""
            if (event.M != null) {
              dayhours += "Monday=" + event.M + ";"
              delete event.M
            }
            if (event.T) {
              dayhours += "Tuesday=" + event.T + ";"
              delete event['T']
            }
            if (event.W) {
              dayhours += "Wednesday=" + event.W + ";"
              delete event.W
            }
            if (event.TH) {
              dayhours += "Thursday=" + event.TH + ";"
              delete event.TH
            }
            if (event.F) {
              dayhours += "Friday=" + event.F + ";"
              delete event.F
            }
            if (event.SA) {
              dayhours += "Saturday=" + event.SA + ";"
              delete event.SA
            }
            if (event.SU) {
              dayhours += "Sunday=" + event.SU + ";"
              delete event.SU
            }
            dayhours = dayhours.slice(0, -1);
            event['dayHours'] = dayhours
          }
        }
      }
      //console.log("process_dayhours, after: cust_alert_event_settings: " + JSON.stringify(this.cust_alert_event_settings))
    },
    eval_event() {
      const type = this.add_cust_event_model.eventType
      this.add_cust_event_model = {}
      this.add_cust_event_model.eventType = type
    },
    async add_cust_event() {
      this.loading=true
      this.show_cust_error = false
      this.cust_error_msg = ""
      if (!this.add_cust_event_model.eventName || !this.add_cust_event_model.eventType || !this.add_cust_event_model.template) {
        this.show_cust_error = true
        this.cust_error_msg = "event name, type and template are required"
        this.loading = false
      } else {
        let cust_alert_event_item = []
        if (this.cust_alert_event_settings != null && this.cust_alert_event_settings != "" && Array.isArray(this.cust_alert_event_settings)) {
          cust_alert_event_item = this.cust_alert_event_settings.filter(element => element.eventName === this.add_cust_event_model.eventName)[0]
        }
        if (cust_alert_event_item && cust_alert_event_item.eventName === this.add_cust_event_model.eventName) {
          this.save_cust_event()
        } else {
          let cust_alert_event_items = []
          if (this.cust_alert_event_settings) {
            cust_alert_event_items = this.cust_alert_event_settings.filter(element => element.eventType == this.add_cust_event_model.eventType)
          }
          if (cust_alert_event_items && cust_alert_event_items.length > 2) {
            this.show_cust_error = true
            this.cust_error_msg = "Only three of each event type is allowed, please remove or update current"
            this.loading = false
          } else {
            //limit number of alerts to 8
            if (this.cust_alert_event_settings && this.cust_alert_event_settings.length == 8) {
              this.show_cust_error = true
              this.cust_error_msg = "Only 8 total events are allowed"
              this.loading = false
              this.cancel_save_event()
            } else {
              this.save_cust_event()
            }
          }
        }
      }
    },
    async save_cust_event() {
      //console.log('add cust event model: ' + this.add_cust_event_model)
      this.process_dayhours(this.add_cust_event_model)
      if (!this.show_cust_error) {
        await add_cust_event(this.user.tenant, this.add_cust_event_model)
        this.add_cust_event_model = {}
        this.toggle_div(this.toggle, 'isAddCustEventVisible')
        await this.load_data()
      } else {
        this.cancel_save_event()
      }
    },
    async cancel_save_cust_event() {
      this.toggle_div(this.toggle, 'isAddCustEventVisible')
      this.manage_cust_events = false
      this.add_cust_event_model = {}
      this.cust_error_msg = ""
      this.show_cust_error = false
      await this.load_data()
    },
    async update_cust_event(event_name) {
      let cust_alert_event_item = null
      if (this.cust_alert_event_settings){
        cust_alert_event_item = this.cust_alert_event_settings.filter(element => element.eventName == event_name)[0]
      }
      if (cust_alert_event_item) {
        this.update_toggle_div(this.toggle, 'isAddCustEventVisible', true)
        this.add_cust_event_model = cust_alert_event_item
        this.disable_cust_options = true
        this.disable_cust_name = true
      }
      this.cust_error_msg = ""
      this.show_cust_error = false
    },
    async add_new_alert() {
      this.toggle_div(this.toggle, 'isAddCustEventVisible')
      this.add_cust_event_model = {}
      this.cust_error_msg = ""
      this.show_cust_error = false
      this.disable_cust_options = false
      this.disable_cust_name = false
    },
    // async add_new_vehicle_late_alert() {
    //   this.toggle_div(this.toggle, 'isAddCustEventVisible')
    //   this.add_cust_event_model = {}
    //   this.cust_error_msg = ""
    //   this.show_cust_error = false
    //   this.disable_cust_options = false
    //   this.disable_cust_name = false
    // },
    async delete_cust_event(event_name) {
      this.loading=true
      await delete_cust_event(this.user.tenant, event_name)
      this.show_cust_error = false
      this.cust_error_msg = ""
      await this.load_data()
    },
    isDisabled(event) {
      return (event.eventType != 'hrsbfr')
    },
    isDayDisabled(event) {
      return (event.eventType != 'hrsbday')
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

